<template>
  <div class="table-search-container-tworow">
    <div>
      <a-select
        style="width:150px"
        class="select-container"
        placeholder="请选择任务类型"
        @change="value=>$emit('onChangeType',value)"
      >
        <a-select-option
          v-for="item in raskTypeData"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </a-select-option>
      </a-select>
      <!-- <a-select
        style="width:150px"
        class="select-container"
        placeholder="请选择状态"
        @change="value => $emit('onChangeStatus', value)"
      >
        <a-select-option
          v-for="item in statusData"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </a-select-option>
      </a-select> -->
      <a-select
        v-if="$store.state.user.role===1"
        style="width:200px"
        class="select-container"
        placeholder="请选择企业"
        @change="value => $emit('onChangeCompany', value)"
      >
        <a-select-option
          v-for="item in companyData"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </a-select-option>
      </a-select>
        <a-date-picker
          class="select-container"
          show-time
          placeholder="开始时间"
          @ok="value=>$emit('onStartTime',value)"
        />
        <a-date-picker
          class="select-container"
          show-time
          placeholder="结束时间"
          @ok="value=>$emit('onEndTime',value)"
        />
        <a-input-search
       class="select-container"
        placeholder="请输入内容"
        style="width:250px"
        allow-clear
        @search="value => $emit('onSearch', value)"
      />

      <a-button
        type="primary"
        shape="round"
        icon="plus"
        @click="$emit('editAndAdd')"
      >
        新增任务
      </a-button>
    </div>
    <div >
    <!--  <a-button
        type="primary"
        shape="round"
        icon="download"
        @click="$emit('onExport')"
      >
        导出任务详情
      </a-button>
      <a-button
        type="primary"
        shape="round"
        icon="download"
        @click="$emit('onExportTask')"
      >
        导出任务统计数据
      </a-button>
      <a-button
        type="primary"
        shape="round"
        icon="download"
        @click="$emit('onExportRepresent')"
      >
        导出代表统计数据
      </a-button> -->
      <!-- <a-button
        type="primary"
        shape="round"
        icon="plus"
        @click="$emit('editAndAdd')"
      >
        新增任务
      </a-button> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      statusData: [
        {id: 0, name: '全部'},
        {id: 1, name: '待执行'},
        {id: 2, name: '执行中'},
        {id: 3, name: '审核中'},
        {id: 4, name: '审核失败'},
        {id: 5, name: '已完成'},
      ],
      raskTypeData: [{id: 0, name: '全部'}, {id: 1, name: '线上拜访'}, {id: 2, name: '学术调研'}, {id: 3, name: '科室会通知'}, {
        id: 4, name: '沙龙会' }, { id: 5, name: '科室会邀请讲课' }],
      companyData: [],
    };
  },
  mounted(){
    this.getCompanyList();
  },
  methods: {
    // 获取合作企业   服务商
    async getCompanyList() {
      let result = await this.$http.post('/Company/getCooperationCompanyList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item) => {
          return { name: item.companyInfo.qichacha_name, ...item };
        });
        this.companyData = [...this.companyData, ...data];
      }
    },
  },
};
</script>
<style lang="scss">
.table-search-container-tworow {
  min-height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
   .ant-select-selection {
    border-radius: 15px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
    margin-right: 20px;
  }
  .select-container{
    margin-right: 20px;
  }
}
</style>
